import { render, staticRenderFns } from "./TableHistorico.vue?vue&type=template&id=0ab4e3e5&style=true&"
import script from "./TableHistorico.vue?vue&type=script&lang=js&"
export * from "./TableHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports